<template>
  <v-app id="app_live_tracking">
    <v-container fluid>
      <v-row>
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">TRACKING ANALYSIS</p>

          <p class="custom_page_main_sub_title" style="opacity: 0.6">Analysis of daily traffic data of officer.</p>
        </v-col>
        <v-col class="px-4 mt-7" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="back()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg">
        <v-card-text>
          <v-row align="center" justify="center">
            <v-col cols="12" xs="12" sm="12" md="4" lg="4">
              <v-card class="mx-auto" elevation="0" border="sm opacity-1" rounded="md" @click="allAgents()">
                <template v-slot:title>
                  <p class="custom_page_component_main_title text-body-2 font-weight-bold">ALL</p>
                </template>
                <template v-slot:item>
                  <p class="font-weight-bold custom_page_main_sub_title_very_small_red text-h4">{{
                      this.allOfficerDetails.length
                    }}</p>
                </template>
                <template v-slot:append>
                  <v-avatar tile size="80" class="pa-3" rounded color="#F5F5F5">
                    <v-img class="ml-2" :src="require('@/img/icons/all_vechile.png')"></v-img>
                  </v-avatar>
                </template>
              </v-card>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="4" lg="4">
              <v-card class="mx-auto" elevation="0" border="sm opacity-1" rounded="md" @click="idling()">
                <template v-slot:title>
                  <p class="custom_page_component_main_title text-body-2 font-weight-bold">AVAILABLE</p>
                </template>
                <template v-slot:item>
                  <p class="font-weight-bold custom_page_main_sub_title_very_small_red text-h4">{{
                      this.activeOfficerCount
                    }}</p>
                </template>
                <template v-slot:append>
                  <v-avatar tile size="80" class="pa-3" rounded color="#F5F5F5">
                    <v-img class="ml-0" :src="require('@/img/icons/availbale_vechile.png')"></v-img>
                  </v-avatar>
                </template>
              </v-card>
            </v-col>

            <!-- <v-col cols="12" xs="12" sm="12" md="3" lg="3">
              <v-card class="mx-auto custom_card_box" elevation="0" style="border: #0e41ed solid 1.6px !important;"
                      border="sm opacity-1" rounded="md">
                <template v-slot:title>
                  <p class="custom_page_component_main_title text-body-2 font-weight-bold text-blue-500">ON TRIP</p>
                </template>

                <template v-slot:item>
                  <p class="font-weight-bold  text-h4">{{ this.activeOfficerCount }}</p>
                </template>
                <template v-slot:append>
                  <v-avatar tile size="80" class="pa-3" rounded color="#0e41ed">
                    <v-img class="ml-0" :src="require('@/img/icons/ontrip_vechile.png')"></v-img>
                  </v-avatar>
                </template>
              </v-card>
            </v-col> -->

            <v-col cols="12" xs="12" sm="12" md="4" lg="4">
              <v-card class="mx-auto" elevation="0" border="sm opacity-1" rounded="md" @click="parking()">
                <template v-slot:title>
                  <p class="custom_page_component_main_title text-body-2 font-weight-bold">
                     NOT AVAILABLE
                  </p>
                </template>
                <template v-slot:item>
                  <p class="font-weight-bold custom_page_main_sub_title_very_small_red text-h4">{{
                      this.deactiveOfficerCount
                    }}</p>
                </template>
                <template v-slot:append>
                  <v-avatar tile size="80" class="pa-3" rounded color="#F5F5F5">
                    <v-img class="ml-0" :src="require('@/img/icons/not_availbale_vechile.png')"></v-img>
                  </v-avatar>
                </template>
              </v-card>
            </v-col>
          </v-row>

          <v-divider class="mt-4 mb-4"></v-divider>

          <v-row align="center" style="max-width: 1000px; margin-left: 0;">
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <p class="custom_page_main_title">ACTIVE OFFICERS LIVE LOCATION</p>
              <p class="custom_page_main_sub_title" style="opacity: 0.6">
                Choose officer type to see live officers & details.
              </p>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xs="12" sm="12" md="8" lg="9" class="mt-0">
              <GMapMap :center="mapCenter" :zoom="7" class="custom_card_box d-flex live_tracking_map">
                <GMapMarker v-for="(m, index) in markers" :key="index" :icon="getRotatedIcon(m)" :position="m.position"
                            @click="selectAgent(m)">
                  <GMapInfoWindow v-if="selectedAgent && selectedAgent.agentId === m.agentId" :position="m.position"
                                  @closeclick="closeInfoWindow">
                    <div>
                      <p><strong>Officer Name:</strong> {{ selectedAgentDetails.name }}</p>
                      <p><strong>Email:</strong> {{ selectedAgentDetails.email }}</p>
                      <p><strong>Premise Code:</strong> {{ selectedAgentDetails.prem_code }}</p>
                      <p><strong>Division Code:</strong> {{ selectedAgentDetails.division_code }}</p>
                      <p><strong>Employee ID:</strong> {{ selectedAgent.agent_regnum }}</p>
                    </div>
                  </GMapInfoWindow>
                </GMapMarker>
              </GMapMap>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="4" lg="3">
              <div class="mt-8">
                <p class="custom_page_component_main_title text-subtitle-1 font-weight-bold text-uppercase">LIST OF
                  OFFICERS</p>
                <p class="custom_page_component_main_title text-caption font-weight-medium">List of all live officers &
                  their details.</p>
                <v-divider class="mt-4 mb-4"></v-divider>
                <v-text-field 
                  clearable 
                  label="Search" 
                  placeholder="Search Officers by name or reg number"
                  variant="outlined" 
                  density="comfortable" 
                  class="custom_input_field_color"
                  v-model="searchQuery"
                  @input="filterOfficers"
                ></v-text-field>
              </div>
              <div style="height: 340px !important; overflow-y: auto!important;">
                <v-card 
                  class="mx-auto mb-3 custom_card_box mr-3" 
                  elevation="0" 
                  v-for="agent in filteredOfficers" 
                  :key="agent.id" 
                  border="sm opacity-1" 
                  rounded="md"
                  @click="focusOnOfficer(agent)"
                >
                  <template v-slot:prepend>
                    <v-img :src="`https://backend-ioc.fcpl.biz/SFA/public/${agentImages[agent.agentId]}`"
                           aspect-ratio="1" class="user_image_view">
                    </v-img>
                  </template>

                  <template v-slot:title>
                    <p class="float-end text-body-2 font-weight-bold mb-1">{{ agent.name }}</p>
                  </template>
                  <template v-slot:item>
                    <p class="float-end font-weight-medium custom_page_main_sub_title_very_small_red text-caption mb-3">
                      {{ agent.registration_num != "null" ? agent.registration_num : "" }}</p>
                  </template>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import {google} from '@fawmi/vue-google-maps';
import axios from "axios";

export default {
  name: 'TrackingAnalysis',
  components: {},
  data() {
    return {
      RECOVERYOFFICER: false,
      MARKETINGOFFICER: false,
      imageURL: "",
      markers: {}, 
      agents: [],
      mapCenter: {lat: 7.8731, lng: 80.7718},
      selectedAgent: {},
      selectedAgentDetails: {},
      dialog: false,
      allOfficerDetails: [],
      activeAgents: [],
      activeOfficerCount: 0,
      deactiveOfficerCount: 0,
      agentImages: {},
      searchQuery: '',
      filteredOfficers: [],
    };
  },

  mounted() {
    this.imageURL = process.env.VUE_APP_IMAGE_PUBLIC_URL;
    this.getAllAgentAndCount();

    if (typeof google !== 'undefined' && google.maps) {
      // API is loaded
    } else {
      console.error('Google Maps API is not loaded yet.');
    }

    window.Echo.channel('AssetLine')
        .listen('LocationUpdated', (e) => {
          if (e.location.status === 'logout') {
            this.removeMarker(e.location.agent_id);
            return;
          }

          this.updateUser(e.location);
          this.getAllAgentAndCount();

          const alpha = e.heading;
          this.updateMarkerHeading(alpha);
        });
  },

  methods: {
    // Initialize filtered officers with all active agents
    initFilteredOfficers() {
      this.filteredOfficers = [...this.activeAgents];
    },

    // Filter officers based on search query
    filterOfficers() {
      if (!this.searchQuery) {
        this.filteredOfficers = [...this.activeAgents];
        return;
      }

      const query = this.searchQuery.toLowerCase();
      this.filteredOfficers = this.activeAgents.filter(agent => {
        return (
          (agent.name && agent.name.toLowerCase().includes(query)) ||
          (agent.registration_num && agent.registration_num.toLowerCase().includes(query))
        );
      });
    },

    // Focus on officer in map when clicked from list
    focusOnOfficer(agent) {
      const marker = this.markers.find(m => m.agentId === agent.agentId);
      if (marker) {
        this.mapCenter = marker.position;
        this.selectAgent(marker);
      }
    },

    getRotatedIcon(marker) {
      return {
        url: require('@/img/icons/vechile_icon.png'),
        scaledSize: {width: 40, height: 35},
        rotation: marker.heading,
      };
    },

    updateMarkerHeading(alpha) {
      this.markers.forEach((marker) => {
        marker.heading = alpha;
      });
    },

    closeInfoWindow() {
      this.selectedAgent = null;
    },

    updateUser(vehicle) {
      if (!this.markers || !Array.isArray(this.markers)) {
        this.markers = [];
      }

      const position = {
        lat: parseFloat(vehicle.lat),
        lng: parseFloat(vehicle.lng)
      };

      const existingMarkerIndex = this.markers.findIndex(m => m.agentId === vehicle.agent_id);

      if (existingMarkerIndex !== -1) {
        this.markers[existingMarkerIndex].position = position;
      } else {
        this.markers.push({
          agentId: vehicle.agent_id,
          agent_regnum: vehicle.agent_regnum,
          agnet_name: vehicle.agnet_name,
          position: position
        });
      }

      if (!this.activeAgents || !Array.isArray(this.activeAgents)) {
        this.activeAgents = [];
      }

      const existingAgent = this.activeAgents.find(agent => agent.agentId === vehicle.agent_id);
      if (!existingAgent) {
        this.activeAgents.push({
          agentId: vehicle.agent_id,
          registration_num: vehicle.agent_regnum,
          name: vehicle.agnet_name,
        });
        // Initialize filtered officers when new agents are added
        this.initFilteredOfficers();
      }

      this.getOfficerImage(vehicle.agent_id);
    },

    removeMarker(agentId) {
      this.markers = this.markers.filter(m => m.agentId !== agentId);
      this.activeAgents = this.activeAgents.filter(a => a.agentId !== agentId);
      this.filteredOfficers = this.filteredOfficers.filter(a => a.agentId !== agentId);
    },

    getOfficerImage(agent) {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");

      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("agentId", agent);

      axios.post('/api/getOfficerImage', formData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
          .then(response => {
            if (response.data.http_status === 'success') {
              const userDetails = response.data.data;
              this.$set(this.agentImages, agent, userDetails.user_image);
            }
          })
          .catch(error => {
            console.error("Failed to fetch image:", error);
          });
    },

    selectAgent(agent) {
      this.selectedAgent = agent;
      this.selectedAgentDetails = [];

      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");

      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("agentId", agent.agentId);
      formData.append("itineraryId", agent.itineraryId);
      formData.append("outletId", agent.outletId);

      axios.post('/api/getDetaisFromAgent', formData, {
        headers: {'Authorization': `Bearer ${token}`}
      })
          .then(response => {
            if (response.data.http_status === 'success') {
              this.selectedAgentDetails = response.data.officerDetails;
            }
          })
          .catch(error => {
            console.error("Error fetching agent details:", error);
          });
      this.dialog = true;
    },

    getAllAgentAndCount() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      const formData = new FormData();
      formData.append('userId', userId);

      axios.post('/api/getAllAgentAndCount', formData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
          .then(response => {
            if (response.status === 200) {
              this.allOfficerDetails = response.data.ofiicerDetails;
              this.activeOfficerCount = response.data.getActiveOfiicer;
              this.deactiveOfficerCount = response.data.getDeactiveOfiicer;
              this.$store.dispatch('updateAgentList', this.allOfficerDetails);
            }
          })
          .catch(error => {
            console.error("Error fetching agent count:", error);
          });
    },

    allAgents() {
      this.$router.push('/all-agents');
    },

    idling() {
      this.$router.push('/idling-agents');
    },

    parking() {
      this.$router.push('/parking-agents');
    },

    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
@import "../../styles/tracking_management/live_tracking.scss";
</style>